var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.9999,
    y: 0.737799,
    width: 21.584,
    height: 21.584,
    rx: 3.65192,
    transform: "rotate(45 15.9999 0.737799)",
    fill: "#59A380",
    stroke: "#FDFFFD",
    strokeWidth: 1.04341
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3848 16.6167H19.4454L17.3241 13.4347H18.3848L16.2635 10.2527L14.1421 13.4347H15.2028L13.0815 16.6167H14.1421L12.0208 19.7987H15.5561V22.274H16.9708V19.7987H20.5061L18.3848 16.6167Z",
    fill: "#FDFFFD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandfill);
export default __webpack_public_path__ + "static/media/landfill.8c7f661374b3aedfb3e0cf1c39454bb2.svg";
export { ForwardRef as ReactComponent };